import {useContext} from "react";

import {HTTPContext} from "../../contexts";

export const useHttp = () => {
    const http = useContext(HTTPContext);
    return http;
};
